import axios from 'axios';

import { PropertyAccessInstructionDto } from '../dtos/access-instructions.dto.interface';

class AccessInstructionsService {
  async getByProperty(propertyId: string): Promise<PropertyAccessInstructionDto | null> {
    const { data } = await axios.get(`property/${propertyId}/access-instructions`);

    return data;
  }

  async create(
    propertyId: string,
    payload: { instructions: string; expiresAt?: string },
  ): Promise<PropertyAccessInstructionDto> {
    const { data } = await axios.post(`property/${propertyId}/access-instructions`, payload);

    return data;
  }

  async update(
    propertyId: string,
    instructionId: string,
    payload: { instructions: string; expiresAt?: string; isValid?: boolean },
  ): Promise<PropertyAccessInstructionDto> {
    const { data } = await axios.patch(`property/${propertyId}/access-instructions/${instructionId}`, payload);

    return data;
  }

  async remove(propertyId: string, instructionId: string): Promise<void> {
    await axios.delete(`property/${propertyId}/access-instructions/${instructionId}`);
  }
}

export default new AccessInstructionsService();
